import React, { Component } from 'react';
import { Link } from 'react-router';
import $ from 'jquery';
import Swiper from 'react-id-swiper';
import {connect,bindActionCreators} from 'react-redux';
import * as actions from '../../../actions';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

class WebRecommended extends Component{
	constructor(props){
		super(props);
		this.state={
			tot_data:[],
			product_offers:[],
			seed_offers:[],
			offers:[],
			status:'',
			suggetions:[],
			pro_recommended:[]			
		}
		this.getOffers=this.getOffers.bind(this);
	    this.goPrev =this.goPrev.bind(this);
	    this.goNext =this.goNext.bind(this);
        this.swiper = null;
	 }
	componentDidMount()
	{
		this.getOffers();
		this.props.recommendedforyou();
	}
  //   componentWillMount(){
		// this.props.recommendedforyou();
		// if(this.props.recommended.suggetions)
		// {
		// 			this.setState({
		// 				suggetions: this.props.recommended.suggetions,
		// 			})			
		// }		
  //   }	
	getOffers()
	{
		var data1={from:'desktop_web'};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'getOffers',
			success:function(data)
			{
			   if(data.status==='available')
				{
					this.setState({
						tot_data:data,
						product_offers:data.product_offers,
						seed_offers:data.seed_offers,
						offers:data.offers,
					    status:'available',
					});
				}
			}.bind(this),
			error:function(err)
			{
			}
		});
	}
	goNext()
	{
	    if(this.swiper) this.swiper.slideNext()
	}
	goPrev()
	{
    	if(this.swiper) this.swiper.slidePrev()
  	}

	
	render()
	{
		const params = {
	      paginationClickable: true,
	      spaceBetween: 10,
	      slidesPerView: 2.8,
	      // autoplay:3000,
	      autoplayDisableOnInteraction:false,
	      // loop:true,
	      // pagination: '.swiper-pagination'
	      navigation: {
		        nextEl: '.swiper-button-next',
		        prevEl: '.swiper-button-prev'
		    },
		  observer: true,
		  rebuildOnUpdate: true  
	    }
const recommended = this.props.recommended.suggetions;

if(this.props.recommended.suggetions)
{

		var pro_recommended = recommended.map(function(product, index) {
	      return (
	        	<Link className="web_promo_ofr_item" to={"web/"+product.redirect_url} >
	              <div className="web_promo_product_ofer_icon">
	                <img style={{paddingTop: '5px'}} src={product.logo} alt="" />
	              </div>
	              <div className="web_rec_product_cntnt">
	                {product.product ? <h5 className="web_promo_product_title">{product.product}</h5> : <h5>&nbsp;</h5>}
	                {product.mrp ? <h6 className="web_promo_product_desc web_rec_product_desc">MRP &#x20B9;{product.mrp}</h6> : <h6>&nbsp;</h6>}
	              </div>
	              <div className="web_promo_ofer_arrow"><i className="glyphicon glyphicon-menu-right"></i></div>
	          </Link>	          
	      )
	    });
}

		
		var product_offers = this.state.product_offers.map(function(product, index) {
	      return (
	        	<Link className="web_promo_ofr_item" to={"/web/pdetails/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.product_id+"/"+product.deal_id} >
	              <div className="web_promo_product_ofer_icon">
	                <img style={{paddingTop: '5px'}} src={product.img} alt="" />
	              </div>
	              <div className="web_promo_product_cntnt">
	                {product.title ? <h5 className="web_promo_product_title">{product.title}</h5> : <h5>&nbsp;</h5>}
	                {product.desc ? <h6 className="web_promo_product_desc">{product.desc}</h6> : <h6>&nbsp;</h6>}
	              </div>
	              <div className="web_promo_ofer_arrow"><i className="glyphicon glyphicon-menu-right"></i></div>
	          </Link>
	      )
	    });
	    var seed_offers = this.state.seed_offers.map(function(seed, index) {
	        return (
	          	<Link className="web_promo_ofr_item" to={"/web/sdetails/"+seed.url_title+"/"+seed.deal_id}>
	                  <div className="web_promo_seed_ofer_icon">
	                    <img style={{paddingTop:'5px'}} src={seed.img} alt="" />
	                  </div>      
	                  <div className="web_promo_seed_ofer_cntnt">
	                  	{seed.title ? <h5 className="web_promo_seed_title">{seed.title}</h5> : <h5 className="web_promo_seed_title">&nbsp;</h5>} 
	                    {seed.desc ? <h6 className="web_promo_seed_desc">{seed.desc}</h6> : <h6 className="web_promo_seed_desc">&nbsp;</h6>}
	                  </div>
	                  <div className="web_promo_ofer_arrow"><i className="glyphicon glyphicon-menu-right"></i></div>
	            </Link>
	        )
	    });  
	    var offers = this.state.offers.map(function(offer, index) {
	        return (
	          	<Link className="web_promo_ofr_item" to={'/web/offer/'+offer.id+"/details"}> 
	                <div className="web_promo_gen_ofer_icon">
	                      <img src={offer.img=== '' ? baseAssets+'icons/web_icons/offer-icon.png' : offer.img} alt="" />
	                </div>      
	                <div className="web_promo_gen_ofer_cntnt">
	                      {offer.title ? <h5 className="web_gen_title">{offer.title}</h5> : <h5 className="web_gen_title">&nbsp;</h5>}
	                      {offer.desc ? <h6 className="web_gen_desc">{offer.desc}</h6> : <h6 className="web_gen_desc">&nbsp;</h6>}
	                </div>
	                <div className="web_promo_gen_ofer_arrow"><i className="glyphicon glyphicon-menu-right"></i></div>
	            </Link>
	          )
	    });
		return(
		  <section className="container web_promo_blks">
		  
			<div>{this.props.recommended.suggetions != '' ? 

		    	<div className="">
		    		<div className="row">
						<div className="col-lg-6 col-md-6 col-sm-6 text-left">
							<h4 className="web_blk_titles">{this.props.recommended.suggetions != ''  ? 'RECOMMENDED FOR YOU' : ''}</h4>
						</div>
						<div className="col-sm-6 col-md-6 col-lg-6 pull-right">
	                       <div className="pro_sld_ctrls">
				            <a className="left carousel-control pro_sld_lft" onClick={this.goPrev}>
				              <span className="pro_sld_arow" aria-hidden="true"><img src={baseAssets+'images_web/left_arrow.png'} alt="" /></span>
				              <span className="sr-only">Previous</span>
				            </a>
				            <a className="right carousel-control pro_sld_rgt" onClick={this.goNext}>
				              <span className="pro_sld_arow" aria-hidden="true"><img src={baseAssets+'images_web/right_arrow.png'} alt="" /></span>
				              <span className="sr-only">Next</span>
				            </a>
		            	  </div>
						</div>
					</div>
					<div className="webpromotions_page1 web_promo_blk_items">
						<div style={{marginTop:'15px',marginBottom:'15px'}}>
							<Swiper {...params} key={this.state.suggetions} ref={node => node ? this.swiper = node.swiper : ''}>
								{pro_recommended}
							</Swiper>
						</div>
					</div>
			</div>
				: 
				''}</div>


		</section>
		);
	}
}

function mapStateToProps(state){
    return {
 		recommended: state.posts.recommended
    }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ actions }, dispatch);
}

export default connect(mapStateToProps,actions)(WebRecommended);


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Promotions/WebRecommended.js
 **/